import React, { useCallback, useMemo } from 'react';
import { ButtonProps } from 'antd';
import Call from '@mui/icons-material/Call';

import * as config from './config';
import * as S from './styles';

type Props = {
  state: 'disabled' | 'enabled' | 'looking-for-vetter' | 'found-vetter';
  vetter: config.VetterInfo;
  timerNode?: React.ReactNode;
  hideDisclaimer?: boolean;
  isPredemo?: boolean;
} & ButtonProps;

export const InterviewButton: React.FC<Props> = ({
  state,
  vetter,
  timerNode,
  onClick: originalOnClick,
  hideDisclaimer,
  isPredemo,
  ...buttonProps
}) => {
  const noop = useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const styledInterviewProps = useMemo(() => {
    const disabled = state === 'disabled';
    const $submitting =
      state === 'looking-for-vetter' || state === 'found-vetter';
    const $iconSize: 'medium' | 'large' =
      state === 'looking-for-vetter' ? 'large' : 'medium';
    const onClick = $submitting ? noop : originalOnClick;
    const lookingForVetter = state === 'looking-for-vetter';
    const icon = (
      <>
        {state === 'found-vetter' ? (
          <S.IconWithPhotoWrapper>
            <S.Avatar
              src={vetter?.photoLowUrl}
              alt="Vetter's profile picture"
            />
            <Call />
          </S.IconWithPhotoWrapper>
        ) : (
          <S.LoadingIconWrapper lookingForVetter={lookingForVetter}>
            {lookingForVetter && <S.RotatingBorder />}
            <Call />
          </S.LoadingIconWrapper>
        )}
      </>
    );

    return {
      disabled,
      $submitting,
      $iconSize,
      onClick,
      icon,
    };
  }, [state, noop, originalOnClick, vetter]);

  return (
    <>
      <S.Button
        block
        htmlType="submit"
        type="primary"
        {...styledInterviewProps}
        {...buttonProps}
      >
        <S.InnerWrap>
          {config.stateCopy[state].text({ vetter, timerNode, isPredemo })}
        </S.InnerWrap>
      </S.Button>

      {!hideDisclaimer && (
        <S.Typography>
          <S.Text type="secondary">
            {config.stateCopy[state].explanation({ isPredemo })}
          </S.Text>
        </S.Typography>
      )}
    </>
  );
};
